
const digest = '9d42f5607db269692fbf82e478d3fceea8edde3a0c8d92374b96d077ae93b7b0';
const classes = {"wrapper":"_wrapper_1ik51_1"};
const css = `._wrapper_1ik51_1 {
  display: grid;
  grid-template-columns: 145px 1fr;
  row-gap: 7px;
  font-size: 14px;
  width: fit-content;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  